import { render, staticRenderFns } from "./QAProduct.vue?vue&type=template&id=f7961b12"
import script from "./QAProduct.vue?vue&type=script&lang=js"
export * from "./QAProduct.vue?vue&type=script&lang=js"
import style0 from "./QAProduct.vue?vue&type=style&index=0&id=f7961b12&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports